/* eslint-disable camelcase */
import joi from 'joi';

import { validateAndGenerateErrors } from '../../../../core/utils/validation';
import { USER_FIELDS } from './userFormFields';

const user_data_validation = joi.object({
  [USER_FIELDS.NAME]: joi.string().required(),
  [USER_FIELDS.LAST_NAME]: joi.string().required()
});

export const validateUserData = (formData) => {
  return validateAndGenerateErrors(formData, user_data_validation);
};
